import { Payment } from '../../state/payment/payment.types';
import { PaymentProps } from '../Payment/Payment.types';

export const PAYMENTS_CONFIG: Record<
  Exclude<Payment, Payment.Mastercard>,
  Omit<PaymentProps, 'onPress'>
> = {
  [Payment.Visa]: {
    icon: 'visa',
    imageWidth: 40,
    imageHeight: 17,
    imageBackground: 'whiteBackground',
    titleKey: 'paymentVisaTitle',
    subtitleKey: 'paymentVisaSubtitle',
  },
  [Payment.Interac]: {
    image: 'wallet.interacEtransfer',
    imageWidth: 40,
    imageHeight: 40,
    titleKey: 'paymentInteracEtransferTitle',
    subtitleKey: 'paymentInteracSubtitle',
  },
  [Payment.ApplePay]: {
    icon: 'applePay',
    imageWidth: 40,
    imageHeight: 17,
    imageBackground: 'whiteBackground',
    titleKey: 'paymentApplePayTitle',
    subtitleKey: 'paymentApplePaySubtitle',
  },
};
